var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDemo)?_c('c-alert',{attrs:{"type":"warning"}},[_vm._v(" Извините, но данная возможность не поддерживается в демонстрационном режиме. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }